"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_hook_form_1 = require("react-hook-form");
var utils_1 = require("@hobt/utils");
var schema_validator_1 = require("./schema-validator");
var getDataPath = function (errors) {
    var dataPath = errors
        .filter(function (error) { return error.keyword === 'type'; })
        .map(function (error) { return error.dataPath.replace(/\//g, '.').replace(/^\./, ''); });
    if (Array.isArray(dataPath) && dataPath.length === 0) {
        return null;
    }
    return dataPath[0];
};
/**
 * TODO: Currently, we are mapping the ErrorObject to ErrorObject of type JoiResolver
 */
var parseErrorSchema = function (
// TODO: Remove type any and instead define a specific type
// params will now become an array of Error Objects as well
validationError, validateAllFieldCriteria) {
    if (Array.isArray(validationError)) {
        return validationError.reduce(function (previous, _a) {
            var _b, _c, _d, _e;
            var dataPath = _a.dataPath, keyword = _a.keyword, message = _a.message, params = _a.params;
            var errorMessage = message;
            var errorKeyword = keyword;
            var path = dataPath.replace(/\//g, '.').replace(/^\./, '');
            if (errorKeyword != null && errorKeyword === 'if') {
                return previous;
            }
            if (params != null && Object.keys(params).includes('errors')) {
                var errors = params.errors;
                if (Array.isArray(errors) && errors.length > 0) {
                    if (errorMessage != null && !errorMessage.includes('[HBT_VAL_ERR_')) {
                        // We get the original errors object in the case we don't want to throw a custom error message
                        var originalErrObj = parseErrorSchema(errors, false);
                        var requiredErrObj = errors.filter(function (error) { return error.keyword === 'required'; });
                        if (Array.isArray(requiredErrObj) && requiredErrObj.length > 0) {
                            return __assign(__assign({}, originalErrObj), previous);
                        }
                        if (!utils_1.isNullOrDefault(path) && originalErrObj[path] != null) {
                            errorMessage = originalErrObj[path].message;
                            errorKeyword = originalErrObj[path].type;
                        }
                    }
                    if (utils_1.isNullOrDefault(path)) {
                        path = getDataPath(errors);
                    }
                }
            }
            // If path is null, then we need to check for missing property field
            if (utils_1.isNullOrDefault(path)) {
                if (params.missingProperty == null) {
                    return previous;
                }
                path = "" + params.missingProperty;
            }
            // If path is not null but it does not contain the missingProperty, then we append to the path
            if (params.missingProperty != null &&
                !path.includes(params.missingProperty)) {
                path = path + "." + params.missingProperty;
            }
            if (validateAllFieldCriteria) {
                return __assign(__assign({}, previous), (previous[path] != null
                    ? (_b = {},
                        _b[path] = react_hook_form_1.appendErrors(path, validateAllFieldCriteria, previous, errorKeyword, errorMessage),
                        _b) : (_c = {},
                    _c[path] = previous[path] || __assign({ message: errorMessage, type: params.type || errorKeyword }, {
                        types: (_d = {},
                            _d[keyword] = errorMessage || true,
                            _d),
                    }),
                    _c)));
            }
            return __assign(__assign({}, previous), (_e = {},
                _e[path] = previous[path] || {
                    message: errorMessage,
                    type: params.type || errorKeyword,
                },
                _e));
        }, {});
    }
    return {};
};
exports.hbtResolver = function (schema, enableAjvErrors) {
    if (enableAjvErrors === void 0) { enableAjvErrors = false; }
    var schemaValidator = new schema_validator_1.SchemaValidator(schema, enableAjvErrors);
    return function (data, _, validateAllFieldCriteria) {
        if (_ === void 0) { _ = {}; }
        if (validateAllFieldCriteria === void 0) { validateAllFieldCriteria = false; }
        try {
            schemaValidator.validate(data);
            return { values: data, errors: {} };
        }
        catch (error) {
            return {
                values: {},
                errors: react_hook_form_1.transformToNestObject(parseErrorSchema(error, validateAllFieldCriteria)),
            };
        }
    };
};
